import React from 'react'
import './Services.css'

const ServicesSection1 = () => {
  const services = [

  {
    id: 1,
    title: "Web Design & Development",
    desc: "Build high-performance, responsive websites and mobile apps tailored to your business needs. Our development team focuses on seamless user experience, modern design, and robust functionality to help you grow your digital presence.",
    img: "/webdev.webp",
    link: "/web-development"
  },
  {
    id: 2,
    title: "SEO Optimization",
    desc: "Enhance your website’s visibility on search engines to attract organic traffic. Our SEO strategies include keyword research, on-page optimization, technical SEO, and quality link building to boost your rankings and drive qualified leads.",
    img: "/seo_img.webp",
      link: "/search-engine-optimization"
  },
  {
    id: 3,
    title: "Social Media Marketing",
    desc: "Social media platforms are where billions of people spend a significant portion of their time—making them fertile ground for meaningful brand interactions and customer acquisition.",
    img: "/sem_img.webp",
      link: "/social-media-marketing"
  },
  {
    id: 4,
    title: "Chatbot Development",
    desc: "Improve customer experience and automate interactions with custom-designed chatbots. Our chatbots can handle queries, generate leads, and support sales 24/7, boosting your service efficiency and customer satisfaction.",
    img: "/chatbot.webp",
      link: "/chat-bot-development"
  },
     {
    id: 5,
    title: "Data & Automation Services",
    desc: "Your business generates data every day — from sales, customers, operations, marketing, and employees. But without the right tools, this data stays scattered and unused.",
    img: "/data&auto.webp",
    link: "/data-and-automation-services"
  },
];
  return (
    <div className='backdiv'>
      <div className="services_wrapper_desktop">
        {/* Card 1 */}
        <div className="service_secgrid">
          <div className="secimg_div">
            <img src="/webdev.webp" alt="Web Development" className="zweedo_img" loading='lazy'/>
          </div>
          <div className="service_overlay">
            <div className="serv_cont_div">
              <div>
              <h2 className='serv_heading'>Web Design & Development</h2>
              <p className='serv_text'>Build high-performance, responsive websites and mobile apps tailored to your business needs. Our development team focuses on seamless user experience, modern design, and robust functionality to help you grow your digital presence.</p>
           <a href='/web-development'><button className='service_btn'>Learn more</button></a>
           </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="service_secgrid"> 
          <div className="service_overlay">
            <div className="serv_cont_div_reverse">
              <div>
              <h2 className='serv_heading'>SEO Optimization</h2>
              <p className='serv_text'>Enhance your website’s visibility on search engines to attract organic traffic. Our SEO strategies include keyword research, on-page optimization, technical SEO, and quality link building to boost your rankings and drive qualified leads.</p>
             <a href='/search-engine-optimization'><button className='service_btn'>Learn more</button></a>
              </div>
            </div>
          </div>
          <div className='service_img_overlay'>
           <div className="secimg_div_reverse">
            <img src="/seo_img.webp" alt="SEO Optimization" className="zweedo_img" loading='lazy'/>
          </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="service_secgrid">
          <div className="secimg_div">
            <img src="/sem_img.webp" alt="Search  Media Marketing" className="zweedo_img" loading='lazy'/>
          </div>
          <div className="service_overlay">
            <div className="serv_cont_div">
                <div>
              <h2 className='serv_heading'>Social Media Marketing</h2>
              <p className='serv_text'>Social media platforms are where billions of people spend a significant portion of their time—making them fertile ground for meaningful brand interactions and customer acquisition.</p>
               <a href='/social-media-marketing'><button className='service_btn'>Learn more</button></a>
              </div>
            </div>
          </div>
        </div>


          {/* Card 4 */}
           <div className="service_secgrid"> 
          <div className="service_overlay">
            <div className="serv_cont_div_reverse">
              <div>
              <h2 className='serv_heading'>Chatbot Development</h2>
              <p className='serv_text'>Improve customer experience and automate interactions with custom-designed chatbots. Our chatbots can handle queries, generate leads, and support sales 24/7, boosting your service efficiency and customer satisfaction.</p>
               <a href='/chat-bot-development'><button className='service_btn'>Learn more</button></a>
              </div>
            </div>
          </div>
          <div className='service_img_overlay'>
           <div className="secimg_div_reverse">
            <img src="/chatbot.webp" alt="SEO Optimization" className="zweedo_img" loading='lazy'/>
          </div>
          </div>
        </div>

          <div className="service_secgrid">
          <div className="secimg_div">
            <img src="/data&auto.webp" alt="Search  Media Marketing" className="zweedo_img" loading='lazy'/>
          </div>
          <div className="service_overlay">
            <div className="serv_cont_div">
                <div>
              <h2 className='serv_heading'>Data & Automation Services</h2>
              <p className='serv_text'>Your business generates data every day — from sales, customers, operations, marketing, and employees. But without the right tools, this data stays scattered and unused.</p>
               <a href='/data-and-automation-services'><button className='service_btn'>Learn more</button></a>
              </div>
            </div>
          </div>
        </div>

      </div>


       <div className="services_wrapper_mobile">
      {services.map((service) => (
        <div key={service.id} className="service_mobile_grid">
          {/* Image */}
          <div className="ser_mob_imgdiv">
            <img src={service.img} alt={service.title} className="zweedo_img" loading='lazy'/>
          </div>

          {/* Content Overlap */}
          <div className="serv_mob_overlay">
            <div className="serv_mob_contdiv">
              <div>
              <h2 className='serv_heading'>{service.title}</h2>
              <p className='serv_text'>{service.desc}</p>
              <a href={service.link}>
              <button className='service_btn'>Learn More</button></a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  )
}

export default ServicesSection1
